module.exports = __webpack_public_path__ + "static/media/volleyball.2484b60e.svg";